/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { CardGridButtonProps, CardGridGroup } from './CardGrid';
import { ViewValues } from '../survey-overview-sidebar/viewOptions';
import { BaseScopeQuestion, CardProps } from '../../types/surveyScope';
import { filterMateriality, getMaterialityMap } from '../survey/utils/filters';
import { MaterialityTitle } from '../../utils/materiality';
import { getScopeInfo } from './scopeSelection';
import { Materiality } from '../../types/initiative';
import { QUESTION } from '../../constants/terminology';

export const getMaterialityCards = ({ handleDrilldown, questionList, materiality, blueprint, addBtn, breadcrumbs, surveyData, scopeType }: CardProps) => {

  const isDrilldown = breadcrumbs && breadcrumbs.length > 0;
  const filteredQuestionLists: { [key: string]: BaseScopeQuestion[] } = {
    [Materiality.Low]: [],
    [Materiality.Medium]: [],
    [Materiality.High]: [],
    [Materiality.None]: [],
  };
  const materialityMap = getMaterialityMap(materiality);

  Object.entries(filteredQuestionLists).forEach(([code, data]) => {
    questionList.forEach(question => {
      if (filterMateriality(question, code as Materiality, materialityMap, blueprint)) {
        data.push(question);
      }
    });
  })

  const defaultOptions = (type: Materiality) => {
    const breadcrumbTitle = MaterialityTitle[type];
    const buttons: CardGridButtonProps[] = [];

    buttons.push({
      icon: <i className='fa fa-list text-ThemeTextPlaceholder' />,
      tooltip: `${breadcrumbTitle} ${QUESTION.CAPITALIZED_PLURAL} - Click to view`,
      onClick: () => handleDrilldown(ViewValues.StandardsQuestionList, type, breadcrumbTitle)
    });

    if (!isDrilldown) {
      buttons.push(addBtn(type, breadcrumbTitle));
    }
    const scopeTag = type;
    const { inScope, isPartial } = getScopeInfo(surveyData.scope, scopeTag, scopeType, breadcrumbs, materiality);
    return {
      unitCount: filteredQuestionLists[type].length,
      buttons: buttons,
      title: <span>{breadcrumbTitle}</span>,
      sortTitle: breadcrumbTitle,
      scopeTag,
      inScope,
      isPartial
    };
  };

  const cardGroups: CardGridGroup[] = [
    {
      cards: [
        {
          ...defaultOptions(Materiality.High),
          key: 'scope-cardgriditem-materiality-high',
          description: 'Materiality defines the priority issues for a business. Materiality can be classified as high, medium and low. Those material issues which are denoted as high, are those issues which rank high both in importance to stakeholders and impact on business success.',
          icon: <i
            className='fa fa-tachometer-alt mr-2 bg-danger text-ThemeTextWhite' />,
        },
        {
          ...defaultOptions(Materiality.Medium),
          key: 'scope-cardgriditem-materiality-medium',
          description: 'Materiality defines the priority issues for a business. Materiality can be classified as high, medium and low. Those material issues which are denoted as medium, are those issues which rank medium both in importance to stakeholders and impact on business success.',
          icon: <i
            className='fa fa-tachometer-alt mr-2 bg-warning text-ThemeTextWhite' />,
        },
        {
          ...defaultOptions(Materiality.Low),
          key: 'scope-cardgriditem-materiality-low',
          description: 'Materiality defines the priority issues for a business. Materiality can be classified as high, medium and low. Those material issues which are denoted as low, are those issues which rank low both in importance to stakeholders and impact on business success.',
          icon: <i
            className='fa fa-tachometer-alt mr-2 bg-success text-ThemeTextWhite' />,
        },
        {
          ...defaultOptions(Materiality.None),
          key: 'scope-cardgriditem-materiality-none',
          description: 'Materiality defines the priority issues for a business. Materiality can be classified as high, medium and low. Those issues which are denoted as having no Materiality, are those issues which have no Materiality both in importance to stakeholders and impact on business success.',
          icon: <i
            className='fa fa-tachometer-alt mr-2 background-ThemeTextPlaceholder text-ThemeTextWhite' />,
        },
      ]
    }
  ];
  return cardGroups;
}
